import styled from '@emotion/styled'

export const ButtonWrapper = styled.div`
  flex: none;
  margin: auto;
`
